export const defaultValues = {
	firstName: undefined,
	lastName: undefined,
	companyName: undefined,
	email: undefined,
	message: undefined
}
